import { Button, ButtonBase, styled } from '@mui/material'
import theme from 'config/theme';
import React, { useEffect, useState } from 'react'

const CustomButton = ({ id, name, click, additional_class, icon, disabled, loading, children, dark = false, sx }) => {
  const [time, setTime] = useState(0)
  const ButtonStyled = styled(Button)(() => ({
    backgroundColor: theme.button[dark ? 'dark' : 'light'].backgroundColor,
    color: theme.button[dark ? 'dark' : 'light'].color,
    height: '40px',
    minWidth: '150px',
    borderRadius: '25px',
    padding: '0 32px',
    fontWeight: 'bold',
    fontSize: '18px',
    border: theme.button[dark ? 'dark' : 'light'].border,
    '&:disabled': {
      border: theme.button[dark ? 'dark' : 'light'].border,
      backgroundColor: theme.button[dark ? 'dark' : 'light'].backgroundColor,
      color: theme.button[dark ? 'dark' : 'light'].color,
    }
  }));
  useEffect(() => {
    let interval
    if (loading) {
      interval = setInterval(() => {
        setTime(time => time + 1);
      }, 1000);
    } else {
      clearInterval(interval);
      setTime(0)
    }
    return () => clearInterval(interval);
  }, [loading])

  return (
    <ButtonStyled
      id={id}
      variant="outlined"
      startIcon={icon && typeof icon === 'string' ? <img alt='icon' src={icon} style={{ width: 30, height: 30 }} /> : icon}
      className={`button ${additional_class} ${dark ? 'dark' : ''} ${disabled ? 'disabled' : ''}`}
      sx={{ textTransform: 'none', ...sx }}
      onClick={click}
      disabled={loading || disabled}
    >
      {children}
      {loading ? `Procesando... ${time} seg` : name}
    </ButtonStyled>
  )
}

export default CustomButton

